export default {
  openapp: "បើកកម្មវិធី",
  noStore: "ហាងមិនមានទេ។",
  rating: "ពិន្ទុ:",
  Categories: "ប្រភេទទំនិញ:",
  PreparationTime: "ពេលវេលារៀបចំអាហារ:",
  DeliveryFee: "ថ្លៃដឹកជញ្ជូន",
  FreeDelivery:"ឥតគិតថ្លៃដឹកជញ្ជូន",
  deducedeliveryfee :'បញ្ចុះតំលៃដឹកជញ្ជូន',
  noScore: 'មិនមានការវាយតម្លៃ',
  discountTitle: 'បញ្ចុះតម្លៃ',
  fullReductionTitle: 'ទិញគ្រប់ចំនួនបញ្ចុះតម្លៃ',
  storeFirstTitle: 'បញ្ជាទិញលើកដំបូង',
  promotionTitle: 'ប្រូម៉ូសិន',
  StoreAnnouncement:'សេចក្ដីប្រកាសរបស់ហាង',
  Businesshours: 'ម៉ោងដំណើរការ',
  DeliveryScope:'វិសាលភាពអាជីវកម្ម',
  PaymentMethod: 'សូមជ្រើសរើសវិធីទូទាត់ប្រាក់',
  goAppTip: 'ទៅកាន់ WOWNOW ឥលូវនេះ',
  CashonDelivery: 'ទូទាត់ប្រាក់ពេលទំនិញទៅដល់',
  PayOnline: 'ទូទាត់តាមប្រព័ន្ធអនឡាញ',
  availablecoupons: 'គូប៉ុងហាង',
  Get: 'ទទួលយកគូប៉ុង',
  refresh: 'ធ្វើឱ្យស្រស់',
  MONDAY: 'ច័ន្',
  TUESDAY: 'អង្គារ',
  WEDNESDAY: 'ពុធ',
  THURSDAY: 'ព្រហស្បត៍',
  FRIDAY: 'សុក្រ',
  SATURDAY: 'សៅរ៍',
  SUNDAY: 'អាទិត្យ',
  MerchantService: 'សេវាកម្មហាង'
}